module.exports = __webpack_public_path__ + "img/h5img38.93db9205.png";